import React, { useEffect } from 'react'
import getUrl from 'libraries/front-end-core/core/url'
import { LEGISLATION_KEY_PICKS } from 'constants/feature-flags'
import { LEGISLATION_CATEGORIES, LEGISLATION } from 'constants/controllers'
import LegislationTiledMenuContainer from 'redux/containers/components/tiled-menu/LegislationTiledMenuContainer'
import ConnectedKeyPicks from './ConnectedKeyPicks'

const LegislationFoldersMenu = ({
  aol,
  isLogged,
  isTiledMenuLoaded,
  setSignUpModalIsOpen,
  legislationFolders,
  setLegislationFolders,
  favourites,
  folders,
  ...props
}) => {
  const handleOnClick = (e) => {
    if (!isLogged) {
      e.preventDefault()
      setSignUpModalIsOpen(true)
    }
  }
  const cxNames = {
    tile: {
      borderColor: 'b--dark-orchid',
      iconColor: 'cadet-blue',
      onHover: 'legislation-tile'
    }
  }

  useEffect(() => {
    setLegislationFolders(folders)
  }, [folders])

  return (
    <div className='bg-page-background pv9'>
      <div className='layout-width-constraint legislation-folders-container'>
        {LEGISLATION_KEY_PICKS && (
          <ConnectedKeyPicks
            {...{
              className: 'pv8',
              cxNames,
              iconName: 'icon-legislation',
              handleOnClick,
              getUrl: item => getUrl(LEGISLATION, { path: item.id }),
              newTab: false
            }}
          />
        )}
        <LegislationTiledMenuContainer
          getUrl={query => params => getUrl(LEGISLATION_CATEGORIES, params, query)}
          category='Legislation'
          cxNames={cxNames}
          favourites={favourites}
          folders={folders}
          {...props}
        />
      </div>
    </div>
  )
}

export default LegislationFoldersMenu
